import { createAsyncThunk } from "@reduxjs/toolkit";
import * as DonorServiceApi from "apis/DonorServiceApi";
import { setCampaignDonors } from "./campaignDonors.slice";

export const fetchCampaignDonors = createAsyncThunk(
  "campaigns/campaignDonors/fetchDonors",
  async (campaign_short: string, { dispatch, rejectWithValue }) => {
    try {
      const response = await DonorServiceApi.getCampaignDonorsPOST({
        campaign_short,
      });
      if (Array.isArray(response)) {
        const sortedResponse = response.sort((a, b) => b.amount - a.amount);
        dispatch(setCampaignDonors(sortedResponse));
      } else {
        rejectWithValue("Invalid donors response format");
      }
    } catch (error) {
      const err = error as { response?: { data?: { error?: string } } };
      rejectWithValue(
        err.response?.data?.error || "Failed to fetch campaign donors"
      );
    }
  }
);
